import type { PeriodSummary } from '../lib/types';
import { money, percent, periodLabel } from '../lib/format';

type Row = Omit<PeriodSummary, 'items'>;

export default function HistoryTable({
  rows,
  periodType,
  onPick,
}: {
  rows: Row[];
  periodType: 'week' | 'month';
  onPick?: (row: Row) => void;
}): JSX.Element {
  return (
    <table className="history">
      <thead>
        <tr>
          <th>{periodType === 'week' ? 'Week' : 'Month'}</th>
          <th>Done</th>
          <th>Result</th>
          <th style={{ textAlign: 'right' }}>Money</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => {
          const decided = row.payout;
          return (
            <tr
              key={row.periodKey}
              onClick={() => onPick?.(row)}
              style={onPick ? { cursor: 'pointer' } : undefined}
            >
              <td>
                {periodLabel(periodType, row.periodKey)}
                {row.provisional && <span className="tiny muted"> · in progress</span>}
              </td>
              <td>
                {row.applicable ? (
                  <>
                    {row.doneCount}/{row.totalCount}
                    <span className="tiny muted"> ({percent(row.rate)})</span>
                  </>
                ) : (
                  <span className="muted">—</span>
                )}
              </td>
              <td>
                {decided ? (
                  <span className={`badge ${decided.status === 'paid' ? 'good' : 'bad'}`}>
                    {decided.status === 'paid' ? 'Paid' : 'Withheld'}
                  </span>
                ) : row.applicable ? (
                  <span className={`badge ${row.qualifies ? 'good' : 'bad'}`}>
                    {row.qualifies ? 'Qualifies' : 'No'}
                  </span>
                ) : (
                  <span className="badge">No chores</span>
                )}
              </td>
              <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                {money(decided ? decided.amount : row.totalAmount, row.currency)}
                {row.extrasApproved > 0 && <div className="tiny muted">incl. {money(row.extrasApproved, row.currency)} extra</div>}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
